import { render, staticRenderFns } from "./navigationChild.vue?vue&type=template&id=3c33c599&"
import script from "./navigationChild.vue?vue&type=script&lang=js&"
export * from "./navigationChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports